import {
  ApplicationConfig,
  importProvidersFrom,
  provideExperimentalZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { CommonModule } from '@angular/common';
import { navigationReducer } from './store/navigation/navigation.reducer';
import { formsDataReducer } from './store/forms-data/forms-data.reducer';
import { provideHttpClient } from '@angular/common/http';
import { apiErrorReducer } from './store/api-error/api-error.reducer';
import { apiDataReducer } from './store/api-data/api-data.reducer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideRouter(appRoutes),
    importProvidersFrom(CommonModule),
    provideHttpClient(),
    provideStore({
      navigation: navigationReducer,
      formsData: formsDataReducer,
      apiData: apiDataReducer,
      apiError: apiErrorReducer,
    }),
    provideEffects([]),
  ],
};
